package com.gsb.vyapar.bhagya.interactor.event

import com.gsb.vyapar.bhagya.presentation.auth.event.AuthUiEvents
import com.gsb.vyapar.bhagya.presentation.category.event.CategoriesViewUiEvents
import com.gsb.vyapar.bhagya.presentation.navigation.event.NavigationUiEvents
import com.gsb.vyapar.bhagya.presentation.splash.event.SplashUiEvents

sealed class UiEvents {
    data class Portrait(val isPortrait: Boolean) : UiEvents()
    data class SplashEvents(val splashUiEvents: SplashUiEvents) : UiEvents()
    data class NavigationEvents(val navigationEvents: NavigationUiEvents) : UiEvents()
    data class CategoryEvents(val categoryEvents: CategoriesViewUiEvents) : UiEvents()
    data class AuthEvents(val authUiEvents: AuthUiEvents): UiEvents()
}